import React from 'react';
import styled from 'styled-components';
import { CheckBox, Icon } from '@roo/roo';
import { useSimpleContext } from '../../_context';

const Root = styled.div``;

function Topic(props) {
  const { value = [], handleChange } = props;
  const { state } = useSimpleContext((t) => [t.scientist.topics]);
  const vx = (value || []).filter((v) => state.scientist.topics.find((t) => t.id === v));
  return (
    <Root>
      <div className="t-info" style={{ display: 'inline' }}>
        <Icon name="info-circle-o" />
        青山科技奖申报人的研究方向及规划需覆盖以下议题之一，最多可选择两个相关议题。
      </div>
      <CheckBox.Group value={vx.map(Number)} onChange={handleChange}>
        {state.scientist.topics.map((item, index) => (
          <CheckBox
            key={index}
            value={Number(item.id)}
            disabled={props.disabled || (!vx.includes(item.id) && vx.length === 2)}
          >
            {item.name}
          </CheckBox>
        ))}
      </CheckBox.Group>
    </Root>
  );
}

export default Topic;
